import { render, staticRenderFns } from "./CoaterEditComp.vue?vue&type=template&id=3b9c4812&scoped=true&"
import script from "./CoaterEditComp.vue?vue&type=script&lang=ts&"
export * from "./CoaterEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./CoaterEditComp.vue?vue&type=style&index=0&id=3b9c4812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c4812",
  null
  
)

export default component.exports